/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getApprehendingOfficers = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_APPREHENDING_OFFICERS,
    'api/v1/administrators/apprehending_officers',
    payload,
    callback
  );

export const showApprehendingOfficer = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_APPREHENDING_OFFICER,
    `api/v1/administrators/apprehending_officers/${id}`,
    payload,
    callback
  );

export const createApprehendingOfficer = (payload, callback) =>
  req.create(
    c.CREATE_APPREHENDING_OFFICER,
    'api/v1/administrators/apprehending_officers',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateApprehendingOfficer = (id, payload, callback) =>
  req.update(
    c.UPDATE_APPREHENDING_OFFICER,
    `api/v1/administrators/apprehending_officers/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeApprehendingOfficer = (id, payload, callback) =>
  req.remove(
    c.REMOVE_APPREHENDING_OFFICER,
    `api/v1/administrators/apprehending_officers/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );

export const getRoleList = (
  payload = { is_paginated: 1, sort_by: 'desc' },
  callback
) =>
  req.list(c.GET_ROLE_LIST, 'api/v1/administrators/roles', payload, callback);
